<template>
  <!-- Disclosure button -->
  <div class="db-disclosure">
    <button
      :id="buttonId"
      class="db-button db-disclosure-button db-button-no-radius"
      :aria-expanded="expanded"
      :aria-controls="`${uid}-wrapper`"
      v-on:click="$emit('click')"
    >
      <slot name="button" />
    </button>
    <!-- Content of the disclosure -->
    <Transition
      name="db-height"
      v-on:enter="useEnter"
      v-on:after-enter="useAfterEnter"
      v-on:leave="useLeave"
    >
      <div
        v-show="expanded"
        :id="wrapperId"
        class="db-disclosure-wrapper"
      >
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid'
import { useEnter, useAfterEnter, useLeave } from '@/composables/useTransitionHeight'

withDefaults(
  defineProps<{
    expanded: boolean
  }>(),
  {
    expanded: false,
  },
)

// Bubble up event
defineEmits<{
  (e: 'click'): void
}>()

// Need unique id for aria
const uid = uuidv4()
const buttonId = `${uid}-btn`
const wrapperId = `${uid}-wrapper`
</script>

<style>
@import '@/assets/styles/animations/_transition-height.css';
@import '@/assets/styles/components/wrappers/_disclosure.css';
</style>
